export default "__VITE_ASSET__CMxc_6Mt__"